// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powerbi-layout {
  display: flex;
  height: calc(100vh - 55px);
  position: relative;
  margin-top: 5px;
}
.powerbi-layout .powerbi-content {
  flex: 1 1;
  margin-left: 285px;
  transition: margin-left 0.3s ease;
  overflow-y: hidden;
  position: relative;
  z-index: 1;
}
.powerbi-layout .powerbi-content.menu-collapsed {
  margin-left: 60px;
}

@media (max-width: 768px) {
  .powerbi-layout {
    flex-direction: column;
    height: calc(100vh - 55px);
    margin-top: 8px;
  }
  .powerbi-layout .powerbi-content {
    margin-left: 0 !important;
    width: 100%;
    height: calc(100vh - 140px);
    overflow-y: auto;
  }
  .powerbi-layout.has-mobile-sticky-header {
    height: calc(100vh - 105px) !important;
    margin-top: 40px !important;
  }
  .powerbi-layout.has-mobile-sticky-header .powerbi-content {
    height: calc(100vh - 105px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/PowerBILayout.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AACJ;AACI;EACE,iBAAA;AACN;;AAKA;EACE;IACE,sBAAA;IAEA,0BAAA;IACA,eAAA;EAHF;EAKE;IACE,yBAAA;IACA,WAAA;IACA,2BAAA;IACA,gBAAA;EAHJ;EAOE;IACE,sCAAA;IACA,2BAAA;EALJ;EAOI;IACE,sCAAA;EALN;AACF","sourcesContent":[".powerbi-layout {\r\n  display: flex;\r\n  height: calc(100vh - 55px);\r\n  position: relative;\r\n  margin-top:5px;\r\n\r\n  .powerbi-content {\r\n    flex: 1;\r\n    margin-left: 285px; // Default margin for expanded menu\r\n    transition: margin-left 0.3s ease;\r\n    overflow-y: hidden;\r\n    position: relative;\r\n    z-index: 1; // Keep content above background but below menu\r\n\r\n    &.menu-collapsed {\r\n      margin-left: 60px; // Collapsed menu width\r\n    }\r\n  }\r\n}\r\n\r\n// Mobile responsive adjustments\r\n@media (max-width: 768px) {\r\n  .powerbi-layout {\r\n    flex-direction: column;\r\n    //height: 100vh;\r\n    height:calc(100vh - 55px);\r\n    margin-top:8px;\r\n\r\n    .powerbi-content {\r\n      margin-left: 0 !important;\r\n      width: 100%;\r\n      height: calc(100vh - 140px);\r\n      overflow-y: auto;\r\n    }\r\n\r\n    // Adjust layout when mobile sticky header is visible\r\n    &.has-mobile-sticky-header {\r\n      height: calc(100vh - 105px) !important;\r\n      margin-top: 40px !important;\r\n\r\n      .powerbi-content {\r\n        height: calc(100vh - 105px) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
